import router from '@/router';
import { RouteNames } from '@/enums/routes/RouteNames';
import type { DeliveryOrder } from '@/modules/Logistics/interfaces/DeliveryOrderInterfaces';

export function onProjectRowEvent(record: Pick<DeliveryOrder, 'id'>) {
    return {
        on: {
            click: () => {
                if (!record.id) {
                    return;
                }

                const route = router.resolve({
                    name: RouteNames.project,
                    params: { id: record.id },
                    query: { initialTab: '3' },
                });

                window.open(route.href, '_blank', 'noopener,noreferrer');
            },
        },
    };
}
